<template>
	<div class="main"  id="app">
	   <div class="content">
		   <div class="content_input">
			   <div class="title">
				   <p>管理员登录</p>
			   </div>
			   <el-input v-model="form.user_name" clearable placeholder="用户名"></el-input>
			  
			   <el-input v-model="form.pass_word" style="margin-top: 15px;" clearable show-password placeholder="密码"></el-input>
			   <div class="content_button">
				   <el-button type="primary" @click="SignIn">登录</el-button>
			   </div>
		   </div>
	   </div>
	</div>
</template>

<script>
import ribbon from '@/utils/ribbon.js'
import index from '@/utils/index.js'
import {post,get} from '@/request/http.js'
export default{
	name:'login',
	data(){
		return {
			form:{
				user_name: '',
				pass_word: ''
			}
			
		}
	},
	methods:{
		SignIn() {
			var self=this;
			var url="/index/Login/CheckLogin";
			post(url,this.form).then(function(res){
				if(res.errCode=="0"){
					self.$message({
					  message: res.msg,
					   type: 'error'
					});
					return;
				}
				sessionStorage.setItem("token",res.result.token);
				$("#bgCanvas").hide();
				self.$router.push({name:'home'})
				
			})
		}
	},
	mounted() {
		$("#bgCanvas").show();
	}
}
</script>

<style scoped="scoped">
	@import   '../assets/css/style.css'
</style>
